export default "__VITE_ASSET__Dn1J0Ntt__"